export default "__VITE_ASSET__CuHSrhs2__"